import { Component, OnInit, inject } from '@angular/core';
import { GestaoPaginaService } from '@app/shared/components/api/services/gestao-pagina.service';
import { CommonModule } from '@angular/common';
import { Pagination } from '@app/shared/components/api/models/pagination.model';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { DialogModule } from 'primeng/dialog';
import { Select } from "primeng/select";
import { FormGroup, ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { EnumService } from '@app/shared/components/api/services/enum.service';
import { forkJoin } from 'rxjs';
import { InputText } from 'primeng/inputtext';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-gestao-pagina',
  imports: [
    CommonModule,
    PaginatorControlComponent,
    DataVoidComponent,
    Select,
    DialogModule,
    ReactiveFormsModule,
    InputText,
    ButtonModule
  ],
  providers: [
    GestaoPaginaService,
    EnumService,
  ],
  templateUrl: './gestao-pagina.component.html',
  styleUrl: './gestao-pagina.component.scss'
})
export class GestaoPaginaComponent implements OnInit {
  private readonly gestaoPaginaService = inject(GestaoPaginaService);
  private readonly fb = inject(FormBuilder);
  private readonly enumService = inject(EnumService);
  private readonly messageService = inject(MessageService);
  pagination: Pagination<any> = new Pagination<any>();
  displayDialog = false;
  form!: FormGroup;
  selectedItem: any;
  paginaOptions: any[] = [];
  tipoDadoOptions: any[] = [];
  isEditMode: boolean = false;
  selectedFile: File | null = null;

  ngOnInit(): void {
    this.getAllContents();
    this.loaddropdowns();
    this.form = this.fb.group({
      Id: [null],
      GestaoPaginaENUM: [{ value: null, disabled: false }, Validators.required],
      GestaoPaginaTipoDadoENUM: [{ value: null, disabled: false }, Validators.required],
      Valor: [{ value: null, disabled: false }, Validators.required]
    });

    this.listenTipoDadoChanges();
  }

  getAllContents() {

    const params = {
      PageSize: this.pagination.pageSize || 5,
      PageNumber: this.pagination.pageNumber || 1,
      orderBy: 'id desc',
    }

    this.gestaoPaginaService.list(params).subscribe({
      next: (result) => {
        this.pagination = new Pagination<any>().deserialize(result);
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  loaddropdowns() {
    forkJoin({
      // Enums
      gestaoPagina: this.enumService.getAllGestaoPagina(),
      tipodadoGestaoPagina: this.enumService.getAllGestaoPaginaTipoDado(),
      // Listas
    }).subscribe((response) => {
      // Enums
      if (response.gestaoPagina?.data) {
        this.paginaOptions = Object.entries(response.gestaoPagina.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value as string,
          })
        );
      }
      if (response.tipodadoGestaoPagina?.data) {
        this.tipoDadoOptions = Object.entries(response.tipodadoGestaoPagina.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value as string,
          })
        );
      }
      // Listas

    });
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.getAllContents();
  }

  getIconByTipo(tipo: number): string {
    switch (tipo) {
      case 1:
        return 'pi-file';        // Texto
      case 2:
        return 'pi-image';       // Imagem
      case 3:
        return 'pi-video';       // Vídeo
      case 4:
        return 'pi-link';        // Link
      default:
        return 'pi-folder';
    }
  }

  openEditDialog(item?: any) {
    item ? this.isEditMode = true : this.isEditMode = false;
    this.selectedItem = item;
    this.displayDialog = true;

    if (this.isEditMode) {
      this.form.get('GestaoPaginaENUM')?.disable();
      this.form.get('GestaoPaginaTipoDadoENUM')?.disable();

      this.form.patchValue({
        Id: item.id,
        GestaoPaginaENUM: item.gestaoPaginaENUM,
        GestaoPaginaTipoDadoENUM: item.gestaoPaginaTipoDadoENUM,
        Valor: item.valor
      });
    }
  }

  listenTipoDadoChanges() {
    this.form.get('GestaoPaginaTipoDadoENUM')?.valueChanges.subscribe(tipo => {
      const valorControl = this.form.get('Valor');

      if (tipo === 1 || tipo === 2) {
        valorControl?.setValidators([Validators.required]);
      } else {
        valorControl?.clearValidators();
        valorControl?.setValue(null);
      }

      valorControl?.updateValueAndValidity({ emitEvent: false });
    });
  }

  isInvalid(controlName: string): boolean {
    const control = this.form.get(controlName);
    return !!(control && control.invalid && control.touched);
  }

  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const raw = this.form.getRawValue();

    const formData = new FormData();

    // Cria o objeto que será enviado como payload
    const payloadObj: any = {
      Id: raw.Id ?? 0,
      GestaoPaginaENUM: raw.GestaoPaginaENUM,
      GestaoPaginaTipoDadoENUM: raw.GestaoPaginaTipoDadoENUM
    };

    // Se for TEXTO ou NUMERO
    if (raw.Valor) {
      payloadObj.Valor = raw.Valor;
    }

    // Adiciona o payload como string JSON
    formData.append('payload', JSON.stringify(payloadObj));

    // Se tiver anexo
    if (this.selectedFile) {
      formData.append('anexo', this.selectedFile);
    }

    this.gestaoPaginaService.store(formData).subscribe({
      next: (res) => {
        if (res.retorno?.codigo === 200) {
          this.closeDialog();
          this.getAllContents();

          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Conteúdo atualizado com sucesso.'
          });
        } else {
          this.messageService.add({
            severity: 'warn',
            summary: 'Aviso',
            detail: res.retorno?.mensagem || 'Falha ao atualizar.'
          });
        }
      },
      error: (err) => {
        console.error(err);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Falha na operação.'
        });
      }
    });
  }

  closeDialog() {
    this.displayDialog = false;
    this.form.reset();
    this.selectedItem = null;
  }

}
